import React from 'react';
import { motion } from 'framer-motion';
import { Command, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserAvatar } from '../components/ui/user-avatar';
import { SettingsContent } from '../components/settings/SettingsContent';

const Settings = () => {
  const { userEmail, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="min-h-screen bg-gray-50 dark:bg-gray-900"
    >
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 border-b dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <button onClick={() => navigate('/')} className="flex items-center">
                <Command className="h-8 w-8 text-blue-600" />
                <h1 className="ml-3 text-2xl font-bold text-gray-900 dark:text-white">JLS Apps</h1>
              </button>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-500 dark:text-gray-400">{userEmail}</span>
              <button 
                onClick={logout}
                className="p-2 text-gray-400 hover:text-gray-500 rounded-lg flex items-center gap-2"
              >
                <LogOut className="h-5 w-5" />
              </button>
              <UserAvatar size="sm" />
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto p-4 sm:p-6 lg:p-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">Settings</h1>
        
        {/* Reusable Settings Content */}
        <SettingsContent showProfilePicture={true} />
      </div>
    </motion.div>
  );
};

export default Settings;
